import { render, staticRenderFns } from "./PrintTopbar.vue?vue&type=template&id=24fb0abc&"
import script from "./PrintTopbar.vue?vue&type=script&lang=js&"
export * from "./PrintTopbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports